"use strict";

var moment = require('moment');

var ShineProducts = require('../../products/ShineProducts');

var resolutions = ['daily', 'weekly', 'monthly'];
var date_formats = ['YYYYMMDD', 'GGGGWW', 'YYYYMM'];

function runAnalysis(orders, resolution) {
  if (!resolutions.includes(resolution)) {
    throw new Error('Type must be one of [' + resolutions.join(', ') + ']');
  }

  var format = date_formats[resolutions.indexOf(resolution)];
  var data = {};
  orders.forEach(function (order) {
    if ((order.order_type === '' || order.order_type === 'order') && order.status !== 'canceled' && order.order_date) {
      var date_key = moment(order.order_date).format(format);

      if (!data[date_key]) {
        data[date_key] = [];
      }

      var datum = {
        subtotal: order.client_payment,
        products: []
      };
      order.products.forEach(function (product) {
        var category = ShineProducts.instance().getProductCategory(product);
        var product_subtotal = product.subtotal;
        datum.products.push({
          category: category,
          subtotal: product_subtotal
        });
      });
      data[date_key].push(datum);
    }
  });
  var updates = {};
  Object.keys(data).forEach(function (week) {
    var arr = data[week];
    var datum = {
      count: arr.length,
      sum: Math.round(arr.map(function (_ref) {
        var subtotal = _ref.subtotal;
        return subtotal;
      }).reduce(function (p, v) {
        return p + v;
      }, 0))
    };
    arr.map(function (_ref2) {
      var products = _ref2.products;
      return products.forEach(function (_ref3) {
        var category = _ref3.category,
            subtotal = _ref3.subtotal;

        if (!datum[category]) {
          datum[category] = {
            count: 0,
            subtotal: 0
          };
        }

        datum[category].count += 1;
        datum[category].subtotal += subtotal;
      });
    });
    updates[week] = datum;
  });
  return updates;
}

module.exports = runAnalysis;